import { Component, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { TranslationService } from 'app/core/internationalization/translation.service';

@Component({
  selector: 'kh-renew-class-modal',
  templateUrl: './renew-class-modal.component.html',
  styleUrls: ['./renew-class-modal.component.less'],
  standalone: false
})
export class RenewClassModalComponent {
  private readonly bsModalRef = inject(BsModalRef);
  private readonly translationService = inject(TranslationService);

  public goToContact(): void {
    const url = this.translationService.instant('HELP_CENTER.SUPPORT_ARTICLES_URL');
    window.open(url, '_blank', 'noopener');
    this.cancel();
  }

  public cancel(): void {
    this.bsModalRef.hide();
  }
}
